/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
export * from './dialog-config';
export * from './dialog-ref';
export * from './dialog.service';
export * from './dialog.module';
//# sourceMappingURL=index.js.map